import React from "react";
import PropTypes from "prop-types";

import AfghanistanMapLoader from "./AfghanistanMapLoader.js";
import EasternEuropeMapLoader from "./EasternEuropeMapLoader.js";
import IraqMapLoader from "./IraqMapLoader.js";
import USAMapLoader from "./USAMapLoader.js";
import USATexas23MapLoader from "./USATexas23MapLoader.js";
import VenezuelaMapLoader from "./VenezuelaMapLoader.js";

const MapLoader = (props) => {
	const { baseMap } = props;
	// console.log("map loader", baseMap);
	// default is usa
	return baseMap === "iraq" ? (
		<IraqMapLoader {...props} noTimeline={props.noTimeline} />
	) : baseMap === "craftsman" || baseMap === "usip" ? (
		<AfghanistanMapLoader {...props} noTimeline={props.noTimeline} />
	) : baseMap === "gec" ||
	baseMap === "balticsDemo" ||
	baseMap === "gec_analyst" ||
	baseMap === "gec_dev" ? (
		<EasternEuropeMapLoader {...props} noTimeline={props.noTimeline} />
	) : baseMap === "texas23" || baseMap === "sevenTwenty_uscc" ? (
		<USATexas23MapLoader {...props} noTimeline={props.noTimeline} />
	) : baseMap === "venezuela" || baseMap === "sayara" ? (
		<VenezuelaMapLoader {...props} noTimeline={props.noTimeline} />
	) : baseMap === "sevenTwenty" ||
	baseMap === "bcbs" ||
	baseMap === "dccc" ||
	baseMap === "midterms" ? (
		<USAMapLoader {...props} noTimeline={props.noTimeline} />
	) : (
		<USAMapLoader {...props} noTimeline={props.noTimeline} />
	);
};

MapLoader.propTypes = {
	baseMap: PropTypes.string,
	noTimeline: PropTypes.bool,
};

export default MapLoader;
